module.exports = __webpack_public_path__ + "img/N.838fa01a.svg";